export interface VideoItem {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  thumbnail: string;
  category: string;
  categorySlug: string;
  tags: string[];
  views: number;
  comments: number;
  publishDate: string;
  isHot: boolean;
  isNew: boolean;
  duration: string;
  content: string;
}

export const categories = [
  { name: '明星黑料', slug: 'mingxing-heiliao', icon: 'ri-user-star-line', count: 128 },
  { name: '翻车现场', slug: 'fanche-xianchang', icon: 'ri-alert-line', count: 96 },
  { name: '争议事件', slug: 'zhengyi-shijian', icon: 'ri-scales-line', count: 87 },
  { name: '网红黑料', slug: 'wanghong-heiliao', icon: 'ri-live-line', count: 74 },
  { name: '最新爆料', slug: 'zuixin-baoliao', icon: 'ri-flashlight-line', count: 63 },
  { name: '综艺翻车', slug: 'zongyi-fanche', icon: 'ri-tv-line', count: 55 },
  { name: '采访翻车', slug: 'caifang-fanche', icon: 'ri-mic-line', count: 42 },
  { name: '舞台事故', slug: 'wutai-shigu', icon: 'ri-music-line', count: 38 },
];

export const videos: VideoItem[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店共度八小时全程跟拍曝光',
    slug: 'dingliu-nanxing-shenye-mihui',
    excerpt: '近日有媒体拍到某顶流男星深夜与一名神秘女子一同进入某五星级酒店，直至次日清晨才前后离开。视频画面清晰可见两人举止亲密，引发网友热议。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20scene%20of%20paparazzi%20night%20photography%20outside%20a%20luxury%20hotel%20entrance%20at%20night%2C%20dramatic%20moody%20lighting%20with%20deep%20shadows%2C%20mysterious%20atmosphere%2C%20blurred%20figures%20in%20the%20background%2C%20film%20noir%20style%2C%20high%20contrast%2C%20dark%20ambient%20tone&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    tags: ['顶流男星', '密会', '酒店', '深夜'],
    views: 1285000,
    comments: 36200,
    publishDate: '2026-08-06',
    isHot: true,
    isNew: true,
    duration: '08:32',
    content: '详细内容待补充...',
  },
  {
    id: '2',
    title: '知名女星直播翻车现场！意外曝光豪宅内部奢华装修，网友直呼贫穷限制想象',
    slug: 'zhiming-nvxing-zhibo-fanche',
    excerpt: '某知名女星在家中直播时，镜头不慎扫到豪宅全景，金碧辉煌的装修风格引发网友热议。更令人震惊的是，镜头中似乎出现了一位"不该出现"的男性身影。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dramatic%20live%20streaming%20setup%20in%20a%20luxurious%20mansion%20interior%20with%20golden%20decorations%20and%20chandeliers%2C%20person%20looking%20shocked%20with%20hand%20over%20mouth%2C%20warm%20golden%20lighting%2C%20opulent%20atmosphere%2C%20cinematic%20composition%2C%20dark%20moody%20corners&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    category: '翻车现场',
    categorySlug: 'fanche-xianchang',
    tags: ['知名女星', '直播翻车', '豪宅', '意外曝光'],
    views: 956000,
    comments: 28400,
    publishDate: '2026-08-05',
    isHot: true,
    isNew: true,
    duration: '12:15',
    content: '详细内容待补充...',
  },
  {
    id: '3',
    title: '当红小生综艺录制现场耍大牌！对工作人员爆粗口，节目组紧急删减镜头',
    slug: 'danghong-xiaosheng-shuadapai',
    excerpt: '某当红小生在综艺录制现场因不满游戏规则，当场对工作人员爆粗口，态度极其恶劣。现场工作人员透露，节目组已紧急将该段内容删除，但内部视频已流出。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20tense%20moment%20on%20a%20variety%20show%20recording%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20angry%20confrontation%20between%20a%20young%20man%20and%20staff%20members%2C%20dramatic%20shadows%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20lighting%20with%20dark%20background&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    category: '综艺翻车',
    categorySlug: 'zongyi-fanche',
    tags: ['当红小生', '耍大牌', '综艺', '爆粗口'],
    views: 1820000,
    comments: 52100,
    publishDate: '2026-08-04',
    isHot: true,
    isNew: false,
    duration: '05:47',
    content: '详细内容待补充...',
  },
  {
    id: '4',
    title: '千万粉丝网红被曝抄袭国外博主！逐帧对比实锤，网友：一模一样照着抄',
    slug: 'qianwan-fensi-wanghong-chaoxi',
    excerpt: '拥有千万粉丝的某知名网红近日被网友扒出长期抄袭国外小众博主的视频内容，从选题、运镜到文案几乎完全照搬。逐帧对比视频引爆全网，该网红评论区已沦陷。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20comparison%20of%20two%20similar%20video%20frames%20side%20by%20side%20showing%20plagiarism%2C%20dark%20modern%20studio%20setup%20with%20monitors%2C%20dramatic%20reveal%20moment%2C%20moody%20lighting%2C%20investigative%20journalism%20atmosphere%2C%20deep%20contrast&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    tags: ['千万网红', '抄袭', '国外博主', '实锤'],
    views: 2340000,
    comments: 67800,
    publishDate: '2026-08-03',
    isHot: true,
    isNew: false,
    duration: '15:22',
    content: '详细内容待补充...',
  },
  {
    id: '5',
    title: '某女星红毯摔跤瞬间曝光！疑似高跟鞋被人动手脚，经纪人当场发飙',
    slug: 'nvxing-hongtan-shuaijiao',
    excerpt: '在某大型颁奖典礼红毯环节，一位知名女星突然摔倒在地，场面一度十分尴尬。事后有知情人士爆料，其高跟鞋疑似被人为破坏，经纪人当场与主办方发生激烈争执。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dramatic%20red%20carpet%20event%20scene%20at%20night%20with%20camera%20flashes%2C%20a%20female%20figure%20stumbling%20on%20the%20red%20carpet%2C%20crowd%20gasping%2C%20luxurious%20award%20show%20setting%2C%20glamorous%20yet%20chaotic%20atmosphere%2C%20high%20contrast%20lighting&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    category: '翻车现场',
    categorySlug: 'fanche-xianchang',
    tags: ['女星', '红毯', '摔跤', '高跟鞋'],
    views: 1560000,
    comments: 41300,
    publishDate: '2026-08-02',
    isHot: true,
    isNew: false,
    duration: '03:58',
    content: '详细内容待补充...',
  },
  {
    id: '6',
    title: '知名导演片场怒骂演员视频流出！脏话连篇令人震惊，多名演员已取关',
    slug: 'zhiming-daoyan-pianchang-numa',
    excerpt: '一段某知名导演在片场怒骂演员的视频近日在网络上疯传，视频中该导演脏话连篇、情绪失控。事后多名与其合作过的演员悄悄取关了其社交媒体账号。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20tense%20film%20set%20atmosphere%20with%20movie%20equipment%20and%20cameras%2C%20an%20older%20director%20yelling%20angrily%20at%20actors%2C%20crew%20members%20looking%20uncomfortable%2C%20dramatic%20overhead%20lighting%2C%20behind%20the%20scenes%20documentary%20style%2C%20dark%20moody%20tone&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    category: '争议事件',
    categorySlug: 'zhengyi-shijian',
    tags: ['知名导演', '片场', '怒骂', '演员'],
    views: 987000,
    comments: 35600,
    publishDate: '2026-08-01',
    isHot: false,
    isNew: true,
    duration: '06:41',
    content: '详细内容待补充...',
  },
  {
    id: '7',
    title: '当红小花被拍到与已婚男星深夜同行！男方妻子发文暗示，疑似婚变',
    slug: 'danghong-xiaohua-yihun-nanxing',
    excerpt: '当红小花旦被媒体拍到与某已婚男星深夜同车出行，两人互动亲密。随后男方妻子在社交平台发布了一条意味深长的动态，引发网友对婚变的猜测。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dark%20rainy%20city%20street%20at%20night%20with%20blurred%20car%20windows%2C%20two%20shadowy%20figures%20visible%20inside%20a%20luxury%20vehicle%2C%20neon%20city%20lights%20reflecting%20on%20wet%20pavement%2C%20paparazzi%20style%20photography%2C%20mysterious%20noir%20atmosphere%2C%20high%20contrast&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    tags: ['当红小花', '已婚男星', '深夜同行', '婚变'],
    views: 2120000,
    comments: 78200,
    publishDate: '2026-07-31',
    isHot: true,
    isNew: false,
    duration: '10:08',
    content: '详细内容待补充...',
  },
  {
    id: '8',
    title: '知名歌手演唱会假唱被当场揭穿！口型对不上引发观众愤怒要求退票',
    slug: 'zhiming-geshou-jiachang-jiechuan',
    excerpt: '某知名歌手在万人演唱会上被细心的观众发现全程假唱，现场大屏幕上口型与声音完全对不上。愤怒的歌迷在演出结束后聚集在场馆外高喊退票，场面一度失控。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20massive%20concert%20stadium%20with%20thousands%20of%20fans%20and%20bright%20stage%20lights%2C%20a%20singer%20on%20stage%20with%20microphone%2C%20dramatic%20tension%20in%20the%20air%2C%20some%20audience%20members%20looking%20upset%2C%20epic%20concert%20atmosphere%20with%20dark%20contrast%2C%20cinematic%20wide%20shot&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    category: '翻车现场',
    categorySlug: 'fanche-xianchang',
    tags: ['知名歌手', '假唱', '演唱会', '退票'],
    views: 3450000,
    comments: 125600,
    publishDate: '2026-07-30',
    isHot: true,
    isNew: false,
    duration: '07:19',
    content: '详细内容待补充...',
  },
  {
    id: '9',
    title: '某男团成员私下抽烟喝酒视频流出！粉丝滤镜碎一地，经纪公司紧急回应',
    slug: 'nantuan-chengyuan-sirenyanjiu',
    excerpt: '一段某当红男团成员在私人聚会中抽烟喝酒的视频被匿名人士曝光，与其在公众面前营造的"乖乖仔"形象形成巨大反差。经纪公司火速发布声明。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20private%20party%20room%20with%20neon%20accents%2C%20young%20people%20gathered%20around%20a%20table%20with%20drinks%2C%20smoke%20in%20the%20air%2C%20hidden%20camera%20angle%2C%20underground%20club%20vibe%2C%20dark%20moody%20lighting%2C%20candid%20moment&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    tags: ['男团', '抽烟喝酒', '私下', '经纪公司'],
    views: 1670000,
    comments: 54200,
    publishDate: '2026-07-29',
    isHot: false,
    isNew: true,
    duration: '04:56',
    content: '详细内容待补充...',
  },
  {
    id: '10',
    title: '知名网红直播带货翻车！产品宣传夸大其词被职业打假人当场揭穿',
    slug: 'wanghong-zhibodaihuo-fanche',
    excerpt: '某知名带货网红在直播间宣传一款"神奇"护肤品时，被职业打假人当场扒出产品备案信息与宣传严重不符。直播间瞬间炸锅，品牌方紧急下播。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20e-commerce%20studio%20setup%20with%20bright%20ring%20lights%20and%20product%20display%2C%20an%20influencer%20looking%20shocked%20and%20embarrassed%2C%20chat%20messages%20flooding%20the%20screen%2C%20dramatic%20moment%2C%20modern%20streaming%20equipment%2C%20high%20contrast%20lighting&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    tags: ['网红', '直播带货', '翻车', '打假'],
    views: 890000,
    comments: 31200,
    publishDate: '2026-07-28',
    isHot: false,
    isNew: false,
    duration: '11:34',
    content: '详细内容待补充...',
  },
  {
    id: '11',
    title: '某女演员片场耍大牌拒绝拍吻戏！导演当场摔剧本，剧组停工三天损失惨重',
    slug: 'nvyanyuan-shuadapai-juwenxi',
    excerpt: '某女演员在拍摄现场临时拒拍吻戏，要求使用替身，导演一怒之下当场摔了剧本。由于这场戏是重头戏，剧组被迫停工三天，损失高达百万。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20cameras%20and%20lighting%20equipment%2C%20a%20script%20thrown%20on%20the%20floor%2C%20tense%20atmosphere%20between%20actors%20and%20director%2C%20crew%20members%20standing%20awkwardly%2C%20dramatic%20behind%20the%20scenes%20moment%2C%20cinematic%20lighting%20with%20deep%20shadows&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    category: '争议事件',
    categorySlug: 'zhengyi-shijian',
    tags: ['女演员', '耍大牌', '拒拍吻戏', '导演'],
    views: 745000,
    comments: 28900,
    publishDate: '2026-07-27',
    isHot: false,
    isNew: false,
    duration: '05:12',
    content: '详细内容待补充...',
  },
  {
    id: '12',
    title: '某知名主持人采访中失言辱骂嘉宾！现场录音曝光，电视台发布道歉声明',
    slug: 'zhiming-zhuchiren-shiyan',
    excerpt: '一段某知名主持人在录制间隙辱骂嘉宾的音频近日被工作人员曝光，内容极其恶劣。涉事电视台已紧急发布道歉声明，但网友并不买账，要求该主持人公开道歉。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20interview%20set%20with%20professional%20cameras%20and%20monitors%2C%20a%20host%20and%20guest%20in%20uncomfortable%20tension%2C%20bright%20studio%20lights%20casting%20harsh%20shadows%2C%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20television%20production%2C%20moody%20tone&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    category: '采访翻车',
    categorySlug: 'caifang-fanche',
    tags: ['知名主持人', '失言', '辱骂', '嘉宾'],
    views: 1230000,
    comments: 45600,
    publishDate: '2026-07-26',
    isHot: false,
    isNew: false,
    duration: '04:28',
    content: '详细内容待补充...',
  },
];

export const trendingTags = [
  '顶流男星',
  '直播翻车',
  '假唱',
  '耍大牌',
  '抄袭',
  '婚变',
  '红毯摔跤',
  '带货翻车',
  '深夜密会',
  '片场冲突',
];